/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable, Type } from '@angular/core';
import { dashboard as dashboardAction } from '@app/core/ngrx';
import { AppState, Dashboard } from '@app/core/types';
import { Store } from '@ngrx/store';
import { MONITORING_DASHBOARD_GROUP_NAME } from '../constants/dashboard-id';

@Injectable({ providedIn: 'root' })
export class ReadonlyMonitoringDashboardsService {
  constructor(private store: Store<AppState>) {}
  private dashboards = new Map<string, Dashboard>();
  private dashboardComponents = new Map<string, Type<any>>();
  public registerDashboard(dashboard: Dashboard, component: Type<any>) {
    this.dashboards.set(dashboard.id, dashboard);
    this.dashboardComponents.set(dashboard.id, component);
    this.store.dispatch(dashboardAction({ dashboardGroupName: MONITORING_DASHBOARD_GROUP_NAME, dashboard }));
  }
  public getDashboard(id: string) {
    return this.dashboards.get(id);
  }
  public getDashboardComponent(id: string) {
    return this.dashboardComponents.get(id);
  }
  public getAllDashboards() {
    return Array.from(this.dashboards.values());
  }
  public isReadonlyDashboard(id: string) {
    return this.dashboards.has(id);
  }
}
